
<template>
    <div class="calendar">
        <input type="hidden" id="datepickr_cal" name="checkin-out-cal" />
        <HotelDatePicker ref="hoteldatesform" :alwaysVisible="true" :disabledDates="unavailable" :periodDates="periodDates"
            :priceSymbol="'€'" :showPrice="true" :format="dateFormat" :hoveringTooltip="false"
            :lastDateAvailable="lastDateAvailable" :showYear="true" :firstDayOfWeek="1" :halfDay="true"
            :minNights="roomMinNights" :selectForward="true" :startingDateValue="new Date($attrs.selectedCheckin)"
            :endingDateValue="new Date($attrs.selectedCheckout)" @dayClicked="handleDayClick" @period-selected="getSelectedDate"
            @next-month-rendered="nextMonth" @previous-month-rendered="lastMonth">
        </HotelDatePicker>
    </div>
</template>

<script>
const { debounce } = require("lodash");
import HotelDatePicker from "vue-hotel-datepicker";
import "vue-hotel-datepicker/dist/vueHotelDatepicker.css";
import Helpers from "../helpers";
import moment from "moment";
import VueCookies from 'vue-cookies';

export default {
    components: {
        HotelDatePicker,
    },
    name: 'searchCheckInOut',
    props: {
        lastDateAvailable: {
            type: [Number, Date],
            default: Infinity,
        },
        location: ''
    },
    data() {
        return {
            roomMinNights: 1,
            checkIn: null,
            checkOut: null,
            checkInTemp: null,
            checkOutTemp: null,
            currentUrl: null,
            clickedDate: null,
            search: new URLSearchParams(window.location.search),
            nextDisabledDate: null,
            roomMinNights: 1,
            setMax: false,
            maxNights: null,
            maxNightsTemp: null,
            selectActive: false,
            data: [],
            accoUnavailable: [],
            unavailable: [],
            nextunavailable: [],
            periodDates: [],
            prices: [],
            dataloaded: false,
            getDataCheckin: moment(),
            getDataCheckout: moment().add(1, 'M').endOf('month'),
            renderComponent: true,
        };
    },
    methods: {
        ...Helpers,
        async forceRender() {
            this.renderComponent = false;
            await this.$nextTick();
            this.renderComponent = true;
        },
        nextMonth(event) {
            this.getDataCheckin = moment(event).startOf('month');
            this.getDataCheckout = moment(event).endOf('month');
            this.getData();
        },
        lastMonth(event) {
            this.getDataCheckin = moment(event).startOf('month');
            this.getDataCheckout = moment(event).endOf('month');
            this.getData();
        },
        getSelectedDate(event, checkinDate, checkoutDate) {
            this.selectActive = false
            this.checkIn = checkinDate;
            this.checkOut = checkoutDate;
            this.$emit("periodSelected", [this.checkIn, this.checkOut]);
        },
        async getData() {
            if (this.$attrs.propIDs && this.$attrs.propIDs.length < 10) {
                var propIDs = this.$attrs.propIDs.join('.')
                try {
                    // let response = await fetch(
                    //     this.currentUrl + "/api/" +
                    //     this.$attrs.clientID +
                    //     "/getCalendar?propID=" + propIDs + "&checkin=" + this.getDataCheckin.format('YYYY-MM-DD') + "&checkout=" + this.getDataCheckout.format('YYYY-MM-DD'),
                    //     {
                    //         headers: {
                    //             "Content-Type": "application/json",
                    //             "X-Requested-With": "XMLHttpRequest",
                    //         },
                    //     }
                    // );
                    // this.data = await response.json();

                    // this.dataloaded = true;

                    // this.unavailable.push(...this.data.unavailable);
                    // this.accoUnavailable.push(...this.data.unavailable)
                    // this.periodDates.push(...this.data.periodDates);

                } catch (error) {
                    console.log(error);
                }
            }
        },
        handleDayClick(event, date, formatDate, resetCheckin) {

            this.nextPeriodDisableDates = [];
            this.setMax = true;

            if (resetCheckin) {
                this.clearSelection();
                this.$nextTick(() => {
                    this.handleDayClick(event, date, formatDate, false);
                });
                this.unavailable = this.accoUnavailable;
                return;
            }
        },
    },
    created() {
        this.currentUrl = window.location.origin;
        this.getData();
    },
    watch: {
        location: function (newVal, oldVal) { // watch it
            this.unavailable = [];
            this.accoUnavailable = [];
            this.maxNights = null;
            this.periodDates = [];
            if (!this.checkIn) {
                this.checkIn = moment();
            }
            this.getDataCheckin = moment(this.checkIn).startOf('month');
            this.getDataCheckout = moment(this.checkIn).add(1, 'M').endOf('month')
            this.getData();
            this.forceRender();
        },
        selectActive: function (newVal, oldVal) {
            if (newVal) {
                this.clickedDate = null
            }
        }

    },
    computed: {
        dateFormat() {
            return "YYYY-MM-DD";
        },
    }
}
</script>